import { Switch } from "@mui/material";
import { styled } from "@mui/material/styles";

const CustomSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#3787B8',
    '&:hover': {
      backgroundColor: 'rgba(55, 135, 184, 0.08)',
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#3787B8',
  },
  '& .MuiSwitch-track': {
    backgroundColor: '#D1D5DB', // Tailwind gray-300
    opacity: 1,
  },
}));

export default CustomSwitch;
